<template>
  <v-card>
    <v-card-title>
      <v-flex xs2>
        <div class="title">Factors</div>
      </v-flex>
      <v-flex xs6>
        <v-text-field append-icon="mdi-magnify" label="Search" single-line hide-details v-model="search"></v-text-field>
      </v-flex>
      <v-flex xs4>
        <v-layout row>
          <v-spacer></v-spacer>
          <v-menu offset-x :nudge-left="370" :close-on-content-click="false" :min-width="300" :max-height="400">
            <v-btn color="secondary" class="white--text" slot="activator">
              <span>Columns</span>
              <v-icon right dark>mdi-table-column-plus-after</v-icon>
            </v-btn>
            <v-card>
              <v-card-text>
                <template v-if="columns.length > 0">
                  <v-checkbox v-for="column in columns" :key="column.value" :label="column.text" :value="column.value" v-model="selectedColumns"></v-checkbox>
                </template>
                <template v-else>
                  No column found
                </template>
              </v-card-text>
            </v-card>
          </v-menu>
        </v-layout>
      </v-flex>
    </v-card-title>
    <v-data-table v-bind:headers="listHeaders" v-bind:items="items" v-bind:search="search" :rows-per-page-items="itemsPerPage" v-bind:pagination.sync="pagination" item-key="key" :loading="loading" :no-data-text="noDataText" :filter="customSearch">
      <template slot="items" slot-scope="props">
      <td v-for="column in selectedColumns" :key="column">
        {{props.item[column]}}
      </td>
      <td class="text-xs-right">
        <table-action :rowData="props" review @review="doReview" remove @remove="doPromptRemove(props.item)"></table-action>
      </td>
      </template>
    </v-data-table>
    <v-btn color="primary" dark class="mb-2" @click="doCreate">New Factor<v-icon>mdi-plus</v-icon></v-btn>
    <confirm v-model="promptRemove" @ok="doRemove">
      Are you sure that you want to delete the selected Tariff Factor?
      <div class="title">{{deleteTarfFact}}</div>
    </confirm>
  </v-card>
</template>

<script>
import MessageMixin from '@/mixins/message'
import { listMixin } from '@/components/parameters/reusable/listMixins'
import { expandURI } from '@/utils/ajax'
import { mapActions } from 'vuex'
import FieldMixin from '@/mixins/field'
export default {
  data() {
    return {
      columns: [
        { text: 'Sequence', value: 'seqNo' },
        { text: 'Factor Description', value: 'description' },
        { text: 'Effective Date', value: 'effDate' },
        { text: 'Expired Date', value: 'expDate' },
        { text: 'Factor 1', value: 'fact1' },
        { text: 'Factor 2', value: 'fact2' },
        { text: 'Factor 3', value: 'fact3' },
        { text: 'Factor 4', value: 'fact4' },
        { text: 'Factor 5', value: 'fact5' },
        { text: 'Factor 6', value: 'fact6' }
      ],
      selectedColumns: ['seqNo', 'description', 'fact1', 'fact2', 'fact3', 'fact4', 'fact5', 'fact6'],
      pagination: {
        sortBy: 'seqNo'
      },
      deleteTarfFact: '',
      promptRemove: false
    }
  },
  watch: {
    'fetchFactor': function(value) {
      if (value !== false) {
        if (this.ids.benefit !== 'new') {
          this.fetchData(this.ids.benefit)
        }
      }
    }
  },
  methods: {
    ...mapActions([
      'tariffBenefitInit'
    ]),
    async fetchData(value) {
      const expand = {
        busCls: this.ids.busCls,
        tarf: this.ids.tarf,
        benefit: value,
        effDate: this.ids.benEffDate
      }
      await this.tariffBenefitInit(expand)
      this.loading = true
      const apiURI = this.$store.state.parameters.tariff.benefit.menu.tarfFactors
      if (apiURI) {
        const expand = {
          busCls: this.ids.busCls,
          tarf: this.ids.tarf,
          benefit: this.ids.benefit
        }
        try {
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result.data
          if (data) {
            this.items = []
            data.map((tarfFactor) => {
              const convertList = {
                benefit: tarfFactor.benefit,
                seqNo: tarfFactor.seqNo,
                effDate: this.formatDate(tarfFactor.effDate),
                expDate: this.formatDate(tarfFactor.expDate),
                description: tarfFactor.description,
                fact1: tarfFactor.factorByFact1,
                fact2: tarfFactor.factorByFact2,
                fact3: tarfFactor.factorByFact3,
                fact4: tarfFactor.factorByFact4,
                fact5: tarfFactor.factorByFact5,
                fact6: tarfFactor.factorByFact6
              }
              this.items.push(convertList)
            })
            this.loading = false
          } else {
            this.items = []
            this.loading = false
          }
        } catch (error) {
          console.log(error)
          const { data } = error.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.loading = false
        }
      } else {
        this.errorMessage('Invalid API Url - Factor List')
        this.loading = false
      }
    },
    doReview(data) {
      this.$emit('doReview', data.item)
    },
    doCreate() {
      this.$emit('doCreate')
    },
    doPromptRemove(data) {
      if (data) {
        this.promptRemove = true
        this.selectedTarfFact = data
        this.deleteTarfFact = data.seqNo + ' - ' + data.effDate
      }
    },
    async doRemove() {
      const apiURI = this.$store.state.parameters.tariff.benefit.menu.tarfFactorDelete
      if (apiURI) {
        this.loading = true
        const formatForm = {
          busCls: this.ids.busCls,
          tarf: this.ids.tarf,
          benefit: this.ids.benefit,
          effDate: this.removeFormatDate(this.selectedTarfFact.effDate),
          seqNo: this.selectedTarfFact.seqNo,
          expDate: this.removeFormatDate(this.selectedTarfFact.expDate),
          description: this.selectedTarfFact.description,
          factorByFact1: this.selectedTarfFact.factorByFact1,
          factorByFact2: this.selectedTarfFact.factorByFact2,
          factorByFact3: this.selectedTarfFact.factorByFact3,
          factorByFact4: this.selectedTarfFact.factorByFact4,
          factorByFact5: this.selectedTarfFact.factorByFact5,
          factorByFact6: this.selectedTarfFact.factorByFact6
        }
        try {
          const result = await this.$http.post(apiURI, formatForm)
          this.notify(result.data)
          // Reinit
          this.fetchData(this.ids.benefit)
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.loading = false
        }
      } else {
        this.$snotify.error('Invalid API URL - Delete Tariff Factor')
      }
    },
    removeFormatDate(date) {
      if (date === null) {
        return null
      } else if (date === undefined) {
        return null
      } else if (date === '') {
        return null
      } else {
        var dateString = date
        var dateParts = dateString.split('/')
        return new Date(dateParts[2], dateParts[1] - 1, dateParts[0])
      }
    }
  },
  props: {
    ids: Object,
    fetchFactor: Boolean
  },
  mixins: [
    listMixin,
    MessageMixin,
    FieldMixin
  ]
}
</script>

<style>

</style>
